module.exports = __webpack_public_path__ + "img/oceanfinance.ba99da1d.png";